/* JLD advertorial sections: option demo toggles (with optional photo swap), product tabs, gallery and review arrows, image zoom. No dependencies. */
(function () {
  function init(root) {
    root.querySelectorAll('[data-ja-group]:not([data-ja-ready])').forEach(function (g) {
      g.setAttribute('data-ja-ready', '');
      g.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || !g.contains(b)) return;
        g.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        swap(g, b);
      });
      // Warm the option photo before the click so the swap feels instant.
      g.addEventListener('pointerover', function (e) {
        var b = e.target.closest('button[data-ja-img]');
        if (b && !b.__jaPre) { b.__jaPre = 1; new Image().src = b.getAttribute('data-ja-img'); }
      });
    });
    // Option button with data-ja-img: show its photo in the section's [data-ja-main] image.
    function swap(g, b) {
      var src = b.getAttribute('data-ja-img');
      var sec = g.closest('section');
      var im = src && sec ? sec.querySelector('[data-ja-main] img') : null;
      if (!im) return;
      var set = b.getAttribute('data-ja-srcset');
      if (set) im.srcset = set; else im.removeAttribute('srcset');
      im.src = src;
      im.loading = 'eager';
      var alt = b.getAttribute('data-ja-alt');
      if (alt) im.alt = alt;
      if (im.hasAttribute('width') && b.getAttribute('data-ja-w')) { im.width = b.getAttribute('data-ja-w'); im.height = b.getAttribute('data-ja-h'); }
    }
    root.querySelectorAll('[data-ja-tabs]:not([data-ja-ready])').forEach(function (t) {
      t.setAttribute('data-ja-ready', '');
      var tabs = t.querySelectorAll('[role=tab]');
      tabs.forEach(function (b) {
        b.addEventListener('click', function () {
          tabs.forEach(function (x) {
            var on = x === b;
            x.setAttribute('aria-selected', on ? 'true' : 'false');
            x.tabIndex = on ? 0 : -1;
            var p = document.getElementById(x.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
      });
    });
    root.querySelectorAll('[data-ja-gallery]:not([data-ja-ready])').forEach(function (g) {
      g.setAttribute('data-ja-ready', '');
      var imgs = g.querySelectorAll('.ja-gal__main img'), th = g.querySelectorAll('.ja-gal__thumbs button'), i = 0;
      function go(n) {
        if (!imgs.length) return;
        i = (n + imgs.length) % imgs.length;
        imgs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); if (k === i) x.loading = 'eager'; });
        th.forEach(function (x, k) { x.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      }
      var p = g.querySelector('.ja-nav--p'), n = g.querySelector('.ja-nav--n');
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (n) n.addEventListener('click', function () { go(i + 1); });
      th.forEach(function (x, k) { x.addEventListener('click', function () { go(k); }); });
    });
    root.querySelectorAll('[data-ja-carousel]:not([data-ja-ready])').forEach(function (c) {
      c.setAttribute('data-ja-ready', '');
      var tr = c.querySelector('.ja-rv__track');
      function step(d) { var f = tr.firstElementChild; tr.scrollBy({ left: d * (f ? f.getBoundingClientRect().width + 16 : tr.clientWidth), behavior: 'smooth' }); }
      var p = c.querySelector('.ja-nav--p'), n = c.querySelector('.ja-nav--n');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });
  }
  // [data-ja-zoom]: open the image large in one shared dialog on this page (no navigation). Bound once even if the script loads twice.
  if (!window.__jaZoom) {
    window.__jaZoom = 1;
    var lb;
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-ja-zoom]') : null;
      if (!b) return;
      e.preventDefault();
      var src = b.getAttribute('data-ja-zoom'), pic = b.querySelector('img');
      if (!window.HTMLDialogElement) { window.open(src, '_blank', 'noopener'); return; }
      if (!lb) {
        lb = document.createElement('dialog');
        lb.className = 'ja-lb';
        lb.innerHTML = '<button type="button" class="ja-lb__x" aria-label="Close">\u00d7</button><img alt="">';
        lb.addEventListener('click', function () { lb.close(); });
        document.body.appendChild(lb);
      }
      var im = lb.querySelector('img');
      im.src = src;
      im.alt = pic ? pic.alt : '';
      lb.showModal();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
